import ErrorOutline from '@mui/icons-material/ErrorOutline'
import { useMutation } from '@tanstack/react-query'
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'
import useDialog from 'hooks/Shared/useDialog'
import useLoadingAdditionalInformation from 'hooks/Shared/useLoadingAdditionalInformation'
import { selectErrorDialog } from 'lib/helpers/errors.helpers'
import { MutationOptions } from 'models/general'
import { IInvoice } from 'models/invoices.models'
import { sendCreditNoteByEmail } from 'services/Invoices/invoices.services'

const useSendCreditNoteByEmail = (
  workspaceId: number,
  options: MutationOptions<void, { creditNote: any; invoice: IInvoice }> = {}
) => {
  const { onSuccess, onError, noDialog } = options

  const dialog = useDialog()
  const showAdditionalInformationLoading = useLoadingAdditionalInformation()

  const mutation = useMutation<
    void,
    any,
    { creditNote: any; invoice: IInvoice }
  >(
    ({ creditNote, invoice }) => {
      if (!invoice || !invoice.idCfdi) throw new Error('CFDI cargado incorrectamente')
      return sendCreditNoteByEmail(
        workspaceId,
        invoice.idCfdi,
        creditNote.idCreditNote
      )
    },
    {
      onMutate: () => {
        showAdditionalInformationLoading()
      },
      onSuccess: (data, variables, ctx) => {
        dialog.close()
        setTimeout(() => {
          onSuccess && onSuccess(data, variables, ctx)
        }, 350)
      },
      onError: async (error, variables, ctx) => {
        setTimeout(async () => {
          const op = selectErrorDialog(error)
          if (op?.variant) {
            await dialog[op.variant](op)
            return
          }
          if (!noDialog) {
            const rp = await dialog.dangerAsync({
              title: 'generic.error.title',
              subtitle:
                'No se pudo eliminar la categoría seleccionada. Intenta nuevamente.',
              icon: ErrorOutline as TModalIcon,
              primaryButtonText: 'Reintentar',
              secondaryButtonText: 'Cancelar',
            })

            if (rp) {
              mutation.mutate(variables)
              return
            }
          }

          onError && onError(error, variables, ctx)
        }, 600)
      },
    }
  )

  return mutation
}

export default useSendCreditNoteByEmail
